module.exports = __webpack_public_path__ + "static/media/back3-min.a1146113.jpg";